import React from "react";
import { Link } from "react-router-dom";
import { Zap, LayoutDashboard, BookOpen } from "lucide-react";
import Layout from "../../components/layout/Layout";
import LoreDashboard from "../../components/dashboard/LoreDashboard";

export default function LorePage() {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <h1 className="text-2xl font-bold text-white">Рабочее пространство</h1>
            <p className="text-neutral-400 text-sm mt-1">Опыт компании и база знаний</p>
          </div>
        </header>

        {/* Navigation Tabs */}
        <div className="flex items-center gap-1 border-b border-neutral-800 pb-px">
          <Link 
            to="/workspace"
            className="px-4 py-2 text-sm font-medium text-neutral-400 hover:text-neutral-200 transition-colors flex items-center gap-2 border-b-2 border-transparent"
          >
            <Zap className="w-4 h-4" />
            AI-Копайлот
          </Link>
          <Link 
            to="/workspace/kanban"
            className="px-4 py-2 text-sm font-medium text-neutral-400 hover:text-neutral-200 transition-colors border-b-2 border-transparent flex items-center gap-2"
          >
            <LayoutDashboard className="w-4 h-4" />
            Доска задач
          </Link>
          <Link 
            to="/workspace/lore"
            className="px-4 py-2 text-sm font-medium text-primary-400 border-b-2 border-primary-500 flex items-center gap-2"
          >
            <BookOpen className="w-4 h-4" />
            База знаний
          </Link>
        </div>

        <div className="bg-white rounded-2xl p-6 min-h-[600px] shadow-sm">
          <LoreDashboard />
        </div>
      </div>
    </Layout>
  );
}
